'use client';

import genplan from '@images/renders/visual_images/genplan.svg';
import image from '@images/renders/visual_images/visual.webp';
import { activeQueueSelector, handleChangeActiveQueue } from '@lib/store/slices/VisualSlice';
import classNames from 'classnames';
import NextImage from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import Svg from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';
import VisualGeneralInfo from 'src/app/visual/components/visual-general-info/VisualGeneralInfo';
import VisualHintInfo from 'src/app/visual/components/visual-hint-info/VisualHintInfo';
import VisualModal from 'src/app/visual/components/visual-modal/VisualModal';
import style from './QueuePlan.module.scss';
let originalEvents = null;
const QueuePlan = ({
  visualInfo,
  sheetRef,
  someStyles,
  isMobile
}) => {
  const [isClient, setClient] = useState(false);
  const [isSvg, setIsSvg] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [positionInfoModal, setPositionInfoModal] = useState({
    left: 0,
    top: 0
  });
  const svgRef = useRef(null);
  const imageRef = useRef(null);
  const leftBlockRef = useRef(null);
  const scrollSnapRef = useRef(null);
  const modalRef = useRef(null);
  const lastChoosenQueue = useRef(null);
  const pathname = usePathname();
  const router = useRouter();
  const dispatch = useDispatch();
  const activeQueue = useSelector(activeQueueSelector);
  const currentBulksIds = activeQueue === 1 ? [9335] : [10099, 9758, 10100];
  const handleShowInfoModal = currentElement => {
    const currentElementRect = currentElement.getBoundingClientRect();
    setTimeout(() => setPositionInfoModal(() => ({
      top: currentElementRect.top + modalRef.current.clientHeight / 2,
      left: currentElementRect.right + 20 + modalRef.current.clientWidth / 2
    })), 10);
    setTimeout(() => setShowInfoModal(() => true), 20);
  };
  const handleHideInfoModal = () => setShowInfoModal(false);
  const handleQueueHover = ({
    queue,
    activeQueueValue,
    className,
    firstQueue,
    secondQueue
  }) => {
    if (activeQueue === null && activeQueueValue === null && svgRef.current) {
      dispatch(handleChangeActiveQueue(null));
      firstQueue.classList.remove(className);
      secondQueue.classList.remove(className);
    }
    if (activeQueue !== activeQueueValue) {
      dispatch(handleChangeActiveQueue(activeQueueValue));
      queue.classList.add(className);
      const otherClassName = className === style.firstActive ? style.secondActive : style.firstActive;
      const otherQueue = queue === firstQueue ? secondQueue : firstQueue;
      if (otherQueue.classList.contains(otherClassName)) {
        otherQueue.classList.remove(otherClassName);
      }
    }
  };
  const beforeSvgInjection = useCallback(() => {
    const firstQueue_0 = document.querySelector('#ochered1');
    const secondQueue_0 = document.querySelector('#ochered2');
    if (!firstQueue_0 || !secondQueue_0) return;
    if (!originalEvents) {
      originalEvents = {
        firstQueue: {
          click: queueId => () => {
            if (isMobile) {
              dispatch(handleChangeActiveQueue(1));
              handleQueueHover({
                queue: firstQueue_0,
                activeQueueValue: 1,
                className: style.firstActive,
                firstQueue: firstQueue_0,
                secondQueue: secondQueue_0
              });
            } else {
              lastChoosenQueue.current = queueId;
              router.push(`${pathname}/${queueId}/9335`);
            }
          },
          mouseenter: () => {
            if (isMobile) return;
            handleShowInfoModal(firstQueue_0);
            handleQueueHover({
              queue: firstQueue_0,
              activeQueueValue: 1,
              className: style.firstActive,
              firstQueue: firstQueue_0,
              secondQueue: secondQueue_0
            });
            lastChoosenQueue.current = 1;
          },
          mouseleave: () => {
            if (isMobile) return;
            handleHideInfoModal();
            handleQueueHover({
              queue: null,
              activeQueueValue: null,
              className: style.firstActive,
              firstQueue: firstQueue_0,
              secondQueue: secondQueue_0
            });
          }
        },
        secondQueue: {
          click: queueId_0 => () => {
            if (isMobile) {
              dispatch(handleChangeActiveQueue(2));
              handleQueueHover({
                queue: secondQueue_0,
                activeQueueValue: 2,
                className: style.secondActive,
                firstQueue: firstQueue_0,
                secondQueue: secondQueue_0
              });
            } else {
              lastChoosenQueue.current = queueId_0;
              router.push(`${pathname}/${queueId_0}`);
            }
          },
          mouseenter: () => {
            if (isMobile) return;
            handleShowInfoModal(secondQueue_0);
            handleQueueHover({
              queue: secondQueue_0,
              activeQueueValue: 2,
              className: style.secondActive,
              firstQueue: firstQueue_0,
              secondQueue: secondQueue_0
            });
            lastChoosenQueue.current = 2;
          },
          mouseleave: () => {
            if (isMobile) return;
            handleHideInfoModal();
            handleQueueHover({
              queue: null,
              activeQueueValue: null,
              className: style.secondActive,
              firstQueue: firstQueue_0,
              secondQueue: secondQueue_0
            });
          }
        }
      };
    }
    if (firstQueue_0.classList.contains(style.firstActive)) {
      firstQueue_0.classList.remove(style.firstActive);
    }
    if (secondQueue_0.classList.contains(style.secondActive)) {
      secondQueue_0.classList.remove(style.secondActive);
    }
    if (activeQueue === 1) firstQueue_0.classList.add(style.firstActive);
    if (activeQueue === 2) secondQueue_0.classList.add(style.secondActive);
    if (activeQueue !== 'first') firstQueue_0.classList.add(style.firstQueue);
    if (activeQueue !== 'second') secondQueue_0.classList.add(style.secondQueue);

    // SETUP ALL EVENTS
    firstQueue_0.onclick = originalEvents.firstQueue.click(1);
    firstQueue_0.onmouseenter = originalEvents.firstQueue.mouseenter;
    firstQueue_0.onmouseleave = originalEvents.firstQueue.mouseleave;
    secondQueue_0.onclick = originalEvents.secondQueue.click(2);
    secondQueue_0.onmouseenter = originalEvents.secondQueue.mouseenter;
    secondQueue_0.onmouseleave = originalEvents.secondQueue.mouseleave;
    if (isMobile) setIsSvg(true);
  }, [svgRef, imageRef]);
  useEffect(() => {
    beforeSvgInjection();
    return () => {
      originalEvents = null;
    };
  }, []);
  useEffect(() => {
    if (isMobile && svgRef) {
      leftBlockRef.current.style.height = `${Math.round(sheetRef?.current?.getBoundingClientRect().y) + 32}px`;
      if (!isSvg) return;
      const container = scrollSnapRef.current;
      const containerWidth = container.offsetWidth;
      const halfContainerWidth = containerWidth / 2;
      container.scrollLeft = container.scrollWidth / 2 - halfContainerWidth;
    }
  }, [svgRef, isSvg]);
  useEffect(() => {
    setClient(true);
  }, []);
  return <>
      <div className={classNames(style.root, someStyles)} ref={leftBlockRef}>
        <div ref={scrollSnapRef} className={isMobile ? style.queueBoxMob : style.queueBox}>
          <NextImage id='gen' ref={imageRef} className={style.image} src={image} alt='Генплан' onLoad={() => beforeSvgInjection()} />

          <div ref={svgRef}>
            <Svg src={genplan.src} className={style.svg} onLoad={() => beforeSvgInjection()} preserveAspectRatio='xMidYMid slice' />
          </div>
        </div>
      </div>
      {!isMobile && isClient && createPortal(<VisualGeneralInfo type='queue' flats={visualInfo.flats} bulkIds={[10099, 9758, 10100, 9335]} />, document.body)}
      {!isMobile && isClient && createPortal(<VisualModal ref={modalRef} open={showInfoModal} position={positionInfoModal}>
            <VisualHintInfo type='queue' flats={visualInfo.flats} bulkIds={currentBulksIds} />
          </VisualModal>, document.body)}
    </>;
};
export default QueuePlan;